import {
  IAnalyticsRepository,
  IAnalyticsRepositoryParams,
  IDisputePipelineRepositoryResponse,
} from "@/core/repositories/analytics";

export class GetDisputePipelineUseCase {
  constructor(private readonly repo: IAnalyticsRepository) {}

  async execute(params: IAnalyticsRepositoryParams): Promise<IDisputePipelineRepositoryResponse> {
    return this.repo.getDisputePipeline(params);
  }
}
